import { useCallback } from "react";
import useMerchantWebPortalAxios from "../../utils/axiosWeb";

function normalizeProvider(provider) {
  return String(provider || "")
    .trim()
    .toLowerCase();
}

function getProviderPath(provider) {
  const normalized = normalizeProvider(provider);
  const providerPaths = {
    alfa: "alfa",
    touch: "touch",
    "mtc touch": "touch",
    sodetel: "sodetel",
    ogero: "ogero",
    terranet: "terranet",
    simly: "simly",
    esim: "esim",
  };

  const providerPath = providerPaths[normalized];

  if (!providerPath) {
    throw new Error("Unsupported utility provider");
  }

  return providerPath;
}

export default function useUtilitiesApi() {
  const webClient = useMerchantWebPortalAxios();

  const getAutomatedBills = useCallback(
    async (provider = "alfa") => {
      const providerPath = getProviderPath(provider);
      const response = await webClient.post(`/${providerPath}/getAutomatedBills`, {
        suyoolUserId: sessionStorage.getItem("webKey"),
      });

      return response?.data;
    },
    [webClient],
  );

  const getUtilityPaymentStatus = useCallback(
    async (provider, mobileNumber) => {
      const providerPath = getProviderPath(provider);
      const utilityIdentifier =
        providerPath === "ogero"
          ? { Landline: mobileNumber }
          : { mobileNumber };
      const response = await webClient.post(
        `/${providerPath}/getStatusPayment`,
        {
          suyoolUserId: sessionStorage.getItem("webKey"),
          ...utilityIdentifier,
        }
      );
      return response?.data;
    },
    [webClient]
  );

  const setUtilityPaymentStatus = useCallback(
    async (provider, payload) => {
      const providerPath = getProviderPath(provider);
      const requestPayload =
        providerPath === "ogero"
          ? (() => {
              const { mobileNumber, ...rest } = payload || {};
              return {
                ...rest,
                Landline: payload?.Landline ?? mobileNumber,
              };
            })()
          : payload;
      const response = await webClient.post(
        `/${providerPath}/setPaymentStatus`,
        requestPayload
      );
      return response?.data;
    },
    [webClient]
  );

  return {
    getAutomatedBills,
    getUtilityPaymentStatus,
    setUtilityPaymentStatus,
  };
}
